export const summaryStyles = {
  root: { width: '100%', padding: '0 0 0 0', margin: '0 0 0 0' },
  singleMenuItem: { paddingTop: '0.75rem', paddingBottom: '0.75rem' },
  content: { padding: '0 0 0 0', margin: '0 0 0 0' },
  divider: { margin: '0' },
  expansionButton: { width: '100%' },
  loweredButtons: { marginTop: 'auto' },
  classic: { background: '#fafafa' },
};
